"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function BaseButton(props) {
    const { className, as, iconLeft, iconRight, children, ...otherProps } = props;
    const buttonClasses = (0, classnames_1.default)("dds-button", className);
    const Component = as || "button";
    return ((0, jsx_runtime_1.jsxs)(Component, { className: buttonClasses, ...otherProps, children: [iconLeft ? ((0, jsx_runtime_1.jsx)("span", { className: "dds-button__icon dds-button__icon--left", children: iconLeft })) : null, children, iconRight ? ((0, jsx_runtime_1.jsx)("span", { className: "dds-button__icon dds-button__icon-right", children: iconRight })) : null] }));
}
exports.default = BaseButton;
//# sourceMappingURL=BaseButton.js.map